export type { IdealPortfolioAdviceCardDisplay } from '../../types/adviceCards.types'
import type {
  ElitePrimeIdealPlanData,
  ElitePrimeStrategyData
} from '../../../../types/elitePrimeSummary.types'
import type { AdviceCardStat, IdealPortfolioAdviceCardDisplay } from '../../types/adviceCards.types'
import {
  buildStrategyFindCopyDisplay,
  buildStrategyUnderReviewStats,
  isStrategyFindCopyStatus,
  isStrategyQuestionnaireSubmittedStatus
} from './adviceCardStrategyStatusDisplay'

function buildActiveIdealPortfolioStats(planData: ElitePrimeIdealPlanData): AdviceCardStat[] {
  const stats: AdviceCardStat[] = []
  const idealFunds = planData.idealFunds ?? 0
  const idealCategories = planData.idealCategories ?? 0

  if (idealFunds > 0) {
    stats.push({ value: `${idealFunds} ideal`, label: 'investments' })
  }

  if (idealCategories > 0) {
    stats.push({ value: `${idealCategories} ideal`, label: 'categories' })
  }

  return stats
}

export function buildIdealPortfolioAdviceCardDisplay({
  planData,
  strategyData
}: {
  planData?: ElitePrimeIdealPlanData
  strategyData?: ElitePrimeStrategyData
}): IdealPortfolioAdviceCardDisplay {
  const status = strategyData?.status

  if (isStrategyFindCopyStatus(status)) {
    return buildStrategyFindCopyDisplay(
      'Find your allocation strategy to get your ideal portfolio'
    )
  }

  if (isStrategyQuestionnaireSubmittedStatus(status)) {
    return {
      stats: buildStrategyUnderReviewStats({
        planLabel: 'Ideal portfolio',
        planAvailableAt: planData?.planAvailableAt,
        planAvailableInDays: strategyData?.planAvailableInDays
      }),
      insightTone: 'orange'
    }
  }

  if (!planData) {
    return { stats: [], insightTone: 'orange' }
  }

  const planAvailableAt = planData.planAvailableAt
  if ((planAvailableAt ?? 0) > Date.now()) {
    return {
      stats: buildStrategyUnderReviewStats({
        planLabel: 'Ideal portfolio',
        planAvailableAt
      }),
      insightTone: 'orange'
    }
  }

  const activeStats = buildActiveIdealPortfolioStats(planData)
  if (activeStats.length > 0) {
    return { stats: activeStats, insightTone: 'orange' }
  }

  return { stats: [], insightTone: 'orange' }
}
